module.exports = __webpack_public_path__ + "media/src/images/icons/star-1e451cf9810f26c64d49a2adf06a0736.svg";